import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
/** @jsx jsx */

import { jsx, Container } from 'theme-ui';
import * as styles from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var MainContainer = function MainContainer(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return jsx(Container, _extends({
    sx: styles.container
  }, rest), children);
};

if (typeof MainContainer !== 'undefined' && MainContainer && MainContainer === Object(MainContainer) && Object.isExtensible(MainContainer) && !MainContainer.hasOwnProperty('__filemeta')) {
  Object.defineProperty(MainContainer, '__filemeta', {
    configurable: true,
    value: {
      name: "MainContainer",
      filename: "node_modules/gatsby-theme-docz/src/components/MainContainer/index.js"
    }
  });
}